<template>
    <div v-if="!$route.meta.hideSideNav" style="display: flex;">
        <!-- 第一層 -->
        <input type="checkbox" class="sr-only sidebar-ctrler" id="v-nav-primary" checked />
        <div class="vertical_nav sidebar sidebar--primary">
            <div class="sidebar__header media">
                <div class="logo-left">
                    <h1 class="logo">
                        <a class="logo__link" href="/home">
                            <img
                                class="logo__img"
                                src="../assets/logo.svg"
                                alt="back"
                                title="中華民國儲蓄互助協會"
                                width="45"
                                height="40"
                            />
                            <small>管理系統</small>
                        </a>
                    </h1>
                </div>
                <div class="media-body text-right">
                    <label class="sidebar-ctrler--label" for="v-nav-primary">
                        <i class="fa fa-ellipsis-v"></i>
                    </label>
                </div>
            </div>
            <div class="menu">
                <div class="sidebar-scroll">
                    <ul class="nav">
                        <!-- <li class="">
                            <a class="waves-effect" href="../dashborad/index.html">
                                <i class="fa fa-tachometer" title="Dashboard"></i>
                                <span class="menu-label">Dashboard</span>
                            </a>
                        </li>-->
                        <!-- <li class="title">
                            <span class="menu-label">參考文件</span>
                        </li>-->
                        <li
                            class="has-sub"
                            v-for="(firstLevel, index) in chosenMenu"
                            :key="index"
                            :class="{active : $route.name == firstLevel.name}"
                        >
                            <router-link
                                :to="{ 'name': firstLevel.name? firstLevel.name : '' ,'query': { type : firstLevel.query } }"
                                class="nav-ctrler waves-effect"
                            >
                                <!-- 管理預設用文件 其餘依照icon的字就可顯示 -->
                                <i
                                    :class="`fa ${firstLevel.icon ? firstLevel.icon : 'fa-file-text-o'}`"
                                    title="UI Elements"
                                ></i>
                                <span class="menu-label">{{firstLevel.title.ch}}</span>
                                <i
                                    class="fa fa-angle-left leftNavIcon"
                                    v-if="firstLevel.children && firstLevel.children.length > 0"
                                ></i>
                            </router-link>
                            <ul v-if="firstLevel.children && firstLevel.children.length > 0">
                                <li
                                    v-for="(secondLevel, index) in firstLevel.children"
                                    :key="index"
                                >
                                    <router-link
                                        class="waves-effect"
                                        :to="{ 'name': secondLevel.name ? secondLevel.name : '', 'query': { type : secondLevel.query } }"
                                    >{{ secondLevel.title.ch }}</router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 第二層 -->
        <input
            type="checkbox"
            class="sr-only sidebar-ctrler"
            id="v-nav-secondary"
            checked
            v-if="$route.meta.submenu"
        />
        <div
            class="vertical_nav sidebar sidebar--secondary event-sidebar"
            v-if="$route.meta.submenu"
        >
            <div class="sidebar__header media">
                <div class="media-left"></div>
                <div class="media-body media-middle text-right">
                    <label class="sidebar-ctrler--label" for="v-nav-secondary">
                        <i class="fa fa-ellipsis-v"></i>
                    </label>
                </div>
            </div>
            <div class="menu">
                <div class="sidebar-scroll">
                    <ul class="nav">
                        <li
                            class
                            v-for="(menu,index) in chosenSubmenu"
                            :key="index"
                            v-if="menu.editshow && $route.params.id !== 'new' && $route.params.code !== 'new' && $route.params.subId !== 'new' || !menu.editshow"
                        >
                            <router-link
                                class="waves-effect"
                                :to="{ name: menu.name? menu.name : '',params: {id: $route.params.id},query: {type : menu.query} }"
                            >
                                <i
                                    :class="`fa ${menu.icon? menu.icon:'fa-file-text-o'}`"
                                    title="Globe"
                                ></i>
                                <span class="menu-label">{{menu.title.ch}}</span>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import { systemMenu } from "@/assets/config";
import { sidenav } from "../assets/sidenav.js";
import { API } from "@/assets/config";

export default {
    name: "sidenav",
    props: ["role"],
    data() {
        return {
            // systemMenu: systemMenu,
            menuData: []
        };
    },
    created() {
        setTimeout(() => {
            this.getMenu();
            sidenav();
        }, 0);
    },
    watch: {
        chosenMenu() {
            setTimeout(() => {
                sidenav();
            }, 0);
        }
    },
    computed: {
        chosenMenu() {
            let arr = [];
            let name = this.$route.path.split("/");
            // name 拆分後的第四個[3]來判斷是哪個menu
            this.menuData.some(item => {
                if (name[3] == item.name) {
                    arr = item.children;
                    return true;
                }
            });
            return arr;
        },
        chosenSubmenu() {
            let arr = [];
            let remove = this.$route.name.split("_");
            let name = this.$route.name.replace(
                `_${remove[remove.length - 1]}`,
                ""
            );
            // 當下編輯頁面去除_edit 就是上一層
            this.chosenMenu.some(item => {
                if (item.name == name && item.submenu) {
                    arr = item.submenu;
                    return true;
                }
                // 下拉選單後的submenu
                if (item.children) {
                    item.children.some(item2 => {
                        if (item2.name == name && item2.submenu) {
                            arr = item2.submenu;
                            return true;
                        }
                        // 下拉選單後的children的submenu
                        if (item2.submenu) {
                            item2.submenu.some(item3 => {
                                if (item3.name == name && item3.submenu) {
                                    arr = item3.submenu;
                                    return true;
                                }
                            });
                        }
                    });
                }
                // 下拉選單後的submenu的submenu
                if (item.submenu) {
                    item.submenu.some(item2 => {
                        if (item2.name == name && item2.submenu) {
                            arr = item2.submenu;
                            return true;
                        }
                    });
                }
            });
            // 暫時隱藏「社員參與狀況」選單，待功能實作後再移除此過濾
            arr = arr.filter(menu => menu.name !== 'coop_anji_memberparticipation');
            // 移除「基本資料」選單
            arr = arr.filter(menu => menu.name !== 'coop_anji_edit');
            return arr;
        }
    },
    methods: {
        getMenu() {
            this.menuData = JSON.parse(localStorage.User).sysPermMenu.menu;
        }
    }
};
</script>